"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {},
    heading: {
      fontSize: theme.typography.pxToRem(26),
      fontWeight: 900,
      lineHeight: 1.48,
      marginTop: '0 !important'
    }
  };
});
var LocationMap = function LocationMap(_ref) {
  var heading = _ref.heading,
    address = _ref.address,
    country = _ref.country,
    zipCode = _ref.zipCode,
    state = _ref.state,
    city = _ref.city,
    googleString = _ref.googleString,
    online = _ref.online,
    anchorId = _ref.anchorId,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      venue: 'Venue'
    } : _ref$translations;
  var classes = useStyles();
  var spacer = __jsx(_core.Grid, {
    item: true,
    sm: 1,
    implementation: "css",
    xsDown: true,
    component: _core.Hidden
  });
  return __jsx(_react.default.Fragment, null, online && online === 'false' ? __jsx("div", {
    id: anchorId,
    className: "aem-ms-cmp aem-ms-map ".concat(classes.wrapper)
  }, heading && __jsx("h2", {
    className: classes.heading
  }, translations.venue, ":", ' ', __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: heading
    }
  })), __jsx(_core.Grid, {
    container: true,
    spacing: 6
  }, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 3,
    md: 3
  }, __jsx("p", null, address && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: address
    }
  }), ' ', __jsx("br", null), city && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(city, ", ")
    }
  }), state && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: " ".concat(state, ", ")
    }
  }), zipCode && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: zipCode
    }
  }), ' ', __jsx("br", null), country && __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: country
    }
  }))), spacer, __jsx(_core.Grid, {
    item: true,
    xs: 12,
    sm: 8,
    md: 8
  }, __jsx("iframe", {
    src: "".concat(googleString),
    title: "".concat(heading),
    width: "100%",
    height: "350",
    frameBorder: "0",
    allowFullScreen: true,
    "aria-hidden": "false",
    tabIndex: 0
  })))) : null);
};
var LocationMapEditConfig = {
  emptyLabel: 'Configure Google Map',
  isEmpty: function isEmpty(props) {
    if (props.heading || typeof props.googleString !== 'undefined') {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/locationmap')(LocationMap, LocationMapEditConfig);
exports.default = _default;